export const environment = {
  production: false,
  useEmulators: false,
  envName: 'dev',
  firebase: {
    apiKey: 'AIzaSyC8t4lOqKKMfSz2wxtJoDQcfUIlbgc6Vow',
    authDomain: 'ventureoff.firebaseapp.com',
    projectId: 'ventureoff',
    storageBucket: 'ventureoff.firebasestorage.app',
    messagingSenderId: '916540834572',
    appId: '1:916540834572:web:407a19d3b72454c6243f29'
  },
  apiUrl: 'https://api-gateway-dev-916540834572.us-central1.run.app/api',
  adminUrl: 'https://dev.platform.ventureoff.co',
  stripePublishableKey: 'pk_test_51Tc63NRMKcWJ1UDXfm9n7EnnvdK2X3s6VifJSRMU7foAXic4Rf9R5nDZk8wX2ozxUjfIKp7I1QuyjFW6ySlJyg9R00F6KHNIth',
  // GA4 measurement id. Leave empty so dev traffic does not pollute the prod
  // property. Set only if a separate dev/test GA4 property is created.
  gaMeasurementId: '',
};
